import React, { useEffect, useState } from 'react'
import Card from '../card.component';
import Modal from '../modal/modal.component';

export default function BultosModalGuia({ show , onConfirm, onCancel, currentValue, backdrop = true }) {

   const [visible, setVisible] = useState(show);
   const [valueText, setValueText] = useState('');

   useEffect(() => {
     setVisible(show);
     if (show) {
        setValueText(currentValue ? currentValue.guia_externa : '');
     }
   },[show])

  return (
    <Modal size="xs" show={visible} backDrop={backdrop}>
      <Card>
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <p>Ingrese guia externa para asociar al bulto:</p>
          <input type="text"
            className={`form-control input-border mt-2`}
            placeholder="0000000000000"
            onChange={(value) => setValueText(value.target.value)}
            value={valueText}
          />
        </div>
        <div>
          <button 
            onClick={() => onCancel()}
            type="button"
            className="btnx btnx-warn"
           >
             Cerrar
           </button>
           {' '}
           <button 
            onClick={() => onConfirm(valueText)}
            type="button"
            className="btnx btnx-warn"
           >
             Confirmar
           </button>
        </div>
       </Card>
    </Modal>
  )
}
